import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import styles from './FraudCase.module.css';

const FraudCase = () => {
  const navigate = useNavigate();
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionChoice, setActionChoice] = useState('Ban all 3 accounts');

  const actionOptions = [
    'Ban all 3 accounts',
    'Suspend primary and warn others',
    'Dismiss as false positive'
  ];

  const headerBadge = <Badge variant="solidDanger">High severity</Badge>;

  const headerActions = (
    <Button
      variant="danger"
      onClick={() => setShowActionModal(true)}
    >
      Take action
    </Button>
  );

  const modalFooter = (
    <>
      <Button variant="secondary" onClick={() => setShowActionModal(false)}>
        Cancel
      </Button>
      <Button
        variant="danger"
        onClick={() => {
          setShowActionModal(false);
          navigate('/safety');
        }}
      >
        Apply action
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/safety"
        backText="← Trust & safety"
        title="FR-112 · Same device on 3 accounts"
        badge={headerBadge}
        subtitle="Detected 2h ago · Device Fingerprint Hash Match · Risk score: 94"
        actions={headerActions}
      />

      <MetricRow columns={3}>
        <MetricCard label="Device model" value="Redmi Note 12" subtext="Android 13 · Chrome 124" />
        <MetricCard label="IP Subnet" value="103.212.x.x" subtext="Jio Mumbai Fiber" />
        <MetricCard label="Incentives at risk" value="₹7,200" subtext="3 studies applied" style={{ color: '#B3261E' }} />
      </MetricRow>

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Linked Account</div>
          <div>Email</div>
          <div>Signed up</div>
          <div>Status</div>
        </div>

        <div className={styles.tableRow}>
          <span className={styles.accountName}>Aman V.</span>
          <span className={styles.emailText}>aman.v99@gmail.com</span>
          <span className={styles.signupText}>Aug 2026</span>
          <span className={styles.flaggedText}>Flagged</span>
        </div>

        <div className={styles.tableRow}>
          <span className={styles.accountName}>Rohan S.</span>
          <span className={styles.emailText}>rohan_s21@gmail.com</span>
          <span className={styles.signupText}>Sep 2026</span>
          <span className={styles.flaggedText}>Flagged</span>
        </div>

        <div className={styles.tableRow}>
          <span className={styles.accountName}>Kual M.</span>
          <span className={styles.emailText}>kunalm@yahoo.com</span>
          <span className={styles.signupText}>Sep 2026</span>
          <span className={styles.flaggedText}>Flagged</span>
        </div>
      </section>

      <Modal
        isOpen={showActionModal}
        onClose={() => setShowActionModal(false)}
        title="Take action on FR-112"
        footer={modalFooter}
        maxWidth={480}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
          <span>Select resolution</span>
          <div className={styles.optionList}>
            {actionOptions.map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => setActionChoice(opt)}
                className={`${styles.optionBtn} ${actionChoice === opt ? styles.optionBtnActive : ''}`.trim()}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FraudCase;
